/**
 * The `exifreader` tag names that the Metadata section of the image edit dialog shows, on every platform.
 * Every other tag of an image (Software, DateTime, BodySerialNumber, LensModel, XMP, thumbnails, ...) stays hidden there,
 * while `ImageMetadata` itself keeps the full tag map for its other readers.
 */
export const DISPLAYED_METADATA_KEYS: ReadonlySet<string> = new Set([
  "Bits Per Sample",
  "Color Components",
  "Color Space",
  "Connection Space",
  "FileType",
  "HasExtendedXMP",
  "ICC Copyright",
  "ICC Description",
  "ICC Profile Date",
  "ICC Signature",
  "Image Height",
  "Image Width",
  "JFIF Thumbnail Height",
  "JFIF Thumbnail Width",
  "JFIF Version",
  "Make",
  "Model",
  "Profile Version",
  "Profile/Device class",
  "Rendering Intent",
  "Resolution Unit",
  "ResolutionUnit",
  "Subsampling",
  "XResolution",
  "YCbCrPositioning",
  "YResolution"
]);
